import React from 'react';

import { Button } from '@this/shared/ui/inputs/button';
import { Text } from '@this/shared/ui/data_displays/typography';
import type TransitList from '@this/domain/transit/transit_list';
import type { TransitMoreDirection } from '@this/domain/transit/transit_list';

type Props = {
  transits: TransitList;
  direction: TransitMoreDirection;
};

const LABELS: Record<TransitMoreDirection, string> = {
  prev: '前の時間を検索する',
  next: '次の時間を検索する'
};

const TransitMoreButton: React.FC<Props> = ({ transits, direction }) => {
  if (!transits.showsMoreButton()) return null;

  const error = transits.moreError[direction];
  const handleClick = () => {
    void transits.handleFetchMore(direction);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '8px',
        padding: '0 10px 10px'
      }}
    >
      {error && (
        <Text level="caption" color="danger">
          {error}
        </Text>
      )}
      <Button
        color="sub"
        size="small"
        loading={transits.moreLoading === direction}
        disabled={!transits.canFetchMore(direction) || transits.moreLoading !== null}
        onClick={handleClick}
      >
        {LABELS[direction]}
      </Button>
    </div>
  );
};

export default TransitMoreButton;
